module.exports = __webpack_public_path__ + "static/img/competitiveness_03@3x.6b17970.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/competitiveness_03@3x.png
// module id = C9I/
// module chunks = 1